import React from 'react';

const ShoppingBasket = () => (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="white">
        <title>shopping-basket</title>
        <path d="M18.399 7h-5.007l-1.812 1.812c-0.453 0.453-1.056 0.702-1.696 0.702-0.642 0-1.244-0.25-1.698-0.703-0.452-0.452-0.702-1.054-0.703-1.695 0-0.039 0.010-0.077 0.011-0.116h-5.894c-0.332 0-0.6 0.268-0.6 0.6v2.4h18v-2.4c0-0.332-0.27-0.6-0.601-0.6zM10.768 7.999l5.055-5.055c0.235-0.234 0.237-0.613 0.002-0.849l-0.92-0.92c-0.234-0.234-0.614-0.233-0.85 0l-5.055 5.056c-0.488 0.488-0.488 1.28 0 1.768 0.488 0.487 1.279 0.488 1.768 0zM3.823 17.271c0.097 0.401 0.515 0.729 0.927 0.729h10.5c0.412 0 0.83-0.328 0.927-0.729l1.523-6.271h-15.4l1.523 6.271z"></path>
    </svg>
);

export default ShoppingBasket;